import type { ModuleNav } from '@saas/ui';

export const CAMPAIGN_READ = ['campaign.campaign.read'];
export const CAMPAIGN_WRITE = ['campaign.campaign.write'];
export const CAMPAIGN_SETTINGS = ['campaign.settings.manage'];

/**
 * campaign（一斉メール・SFA §9.6）のメニュー。業務 = キャンペーンとテンプレート、管理 = 会社の設定と抑止リスト。
 * 抑止リストは read でも見られるが、追加・解除は campaign.settings.manage なので管理メニューに置く
 */
export const campaignNav: ModuleNav = {
  module: 'campaign',
  items: [
    { label: '一斉メール', to: '/campaigns', end: true, icon: 'send', permission: CAMPAIGN_READ, description: '見込み客・連絡先へのお知らせメール（対象者の試算・テスト送信・件数確認・予約・結果）' },
    { label: 'メールのテンプレート', to: '/campaigns/templates', icon: 'description', permission: CAMPAIGN_READ, description: '一斉メールの件名・本文と差し込み変数' },
  ],
  admin: [
    { label: '一斉メールの設定', to: '/campaigns/settings', icon: 'settings', permission: CAMPAIGN_SETTINGS, description: '差出人・特定電子メール法の表示・同意の扱い・頻度の上限・開封 / クリックの計測' },
    { label: '配信の抑止リスト', to: '/campaigns/suppressions', icon: 'block', permission: CAMPAIGN_SETTINGS, description: '不達・苦情・手動で送らないアドレス' },
  ],
};
